import { useState } from "react";
import moment from 'moment';
import { useSnackbar } from 'notistack';
import { Paper, Grid, } from "@mui/material";
import { EndDateFilter, StartDateFilter } from "./DateFilter";
import Header from "./Header";
import AssetFilter from "./AssetFilter";
import { getMonthlyRevenueReportApi } from "../apiService";
import {  globalPostService } from "../../../utils/globalApiServices";
import { checkApiStatus } from "../../../utils";
import { ExportMenu, PageLoader } from "../../../shared_elements";
import { isValidYearRange } from "../../../utils/helper";
import { trackActivity } from "../../../utils/mixpanel";

const MonthlyRevenueReport = ({pltConstants,dropDownLoader}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false)
  const [reportData, setReportData] = useState({});
  const [error, setError] = useState({});
  const onFieldChange = (key, value) => {
    setReportData((prev) => {
      const updatedData = { ...prev, [key]: value };
      if (key === "start_date" && !value) { updatedData.end_date = null; }
      return updatedData;
    });
  };    
  const onFocusChange = (keyParam) => { setError(prev => ({ ...prev, [keyParam]: '' })) }
  const onExportReport = (extention,) => {
    let validationInputs = {};
    validationInputs = {
      start_date: !reportData?.start_date ? "Please select Start Date" : !isValidYearRange(reportData?.start_date) ? "Year must be between 1900 and 2100." : "",
      end_date: !reportData?.end_date ? "Please select End Date" : moment(reportData.end_date).isBefore(moment(reportData.start_date)) ? "End date must be after Start Date" : !isValidYearRange(reportData?.end_date) ? "Year must be between 1900 and 2100." : "",
    };
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
      const payload = {
        file_type: extention,  start_date: reportData?.start_date, end_date: reportData?.end_date,
       ...(reportData?.asset_type_id?.length && {asset_types: reportData.asset_type_id, }),
      };      
      setLoading(true)
      globalPostService(getMonthlyRevenueReportApi(),payload)
        .then(response => {
          setLoading(false)
          if (checkApiStatus(response)) {
            setReportData({})
            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
            trackActivity('Item Export', { page_title: `Monthly Revenue Report`, success_msg: response?.data?.message, payload: payload, response: response?.data })
          } else {
            enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
            trackActivity('Item Export', { page_title: `Monthly Revenue Report`, error_msg: response?.data?.message, payload: payload, response: response?.data })
          }
        });
    } else {
      setError(validationInputs)
      trackActivity('Item Export', { page_title: `Monthly Revenue Report`, error_msg: validationInputs })
    }
  };
  return (
    <Paper square>
      <div className='custom-rpt-card'>
        <div className='rpt-card-header'>
          <Grid container spacing={1} className='rpt-header-grid'>
            <Grid size={{ md: 10, xs: 10 }}>
              <Header title="Monthly Revenue Report" description="Consolidated Monthly Revenue Summary by Asset and Contract. Includes Lease Rentals, Supplemental Rent, Payment Status and Variance Against Forecasts." />
            </Grid>
            <Grid size={{ md: 2, xs: 2 }} sx={{ display: "flex", justifyContent: "flex-end",alignItems: "center"  }}>
              <ExportMenu
                exportReportFn={(file) => onExportReport(file.extension)}
                files={[{ title: 'EXCEL', extension: 'xlsx' }]}
              />
            </Grid>
          </Grid>
        </div>
        <Grid sx={{ padding: 2 }} container spacing={1} >
          <Grid size={{ md: 6, xs: 12 }} >
            <StartDateFilter reportData={reportData} onFieldChange={onFieldChange} onFocusChange={onFocusChange} error={error} isFutureDisabled={true} />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <EndDateFilter reportData={reportData} onFieldChange={onFieldChange} onFocusChange={onFocusChange} error={error} disabled={!reportData?.start_date} />
          </Grid>
          <Grid size={{ md: 12, xs: 12 }}>
            <AssetFilter isRequired={false} error={error} pltConstants={pltConstants} dropDownLoader={dropDownLoader} reportData={reportData} onFieldChange={onFieldChange} onFocusChange={onFocusChange} />
          </Grid>
        </Grid>
      </div>
      {isLoading ? <PageLoader /> : null}
    </Paper>
  )
}

export default MonthlyRevenueReport